import type { Coach, DeepDive } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (deepDive?: DeepDive, coaches?: Coach[]) => {
  useRegisterAgentContext(
    deepDive
      ? {
          kind: 'entity',
          description: 'The deep dive the user is viewing',
          data: deepDive,
        }
      : null,
  );

  useRegisterAgentContext(
    deepDive?.offerings?.length
      ? {
          kind: 'section',
          title: "What's Included",
          description: 'Checklist of offerings included in this deep dive.',
          detail: deepDive.offerings.join('\n'),
        }
      : null,
  );

  useRegisterAgentContext(
    coaches?.length
      ? {
          kind: 'list',
          description: 'Coaches who offer this deep dive',
          data: coaches.map((coach) => ({
            id: coach.id,
            name: `${coach.first_name} ${coach.last_name}`,
            headline: coach.headline,
            job_title: coach.job_title,
            bio: coach.bio,
            employers: coach.employers?.map((e) => e.name),
            education: coach.education?.map((e) => e.name),
          })),
        }
      : null,
  );
};
